import Vue from 'vue'
import Vuex from 'vuex'
import axios,{API_URL} from './helpers/axios'

//--------modulos---------------------
import globals from './modules/global'
import nivelesGrados from './modules/nivelesgrados'
import areas from './modules/areas'
import login from './modules/login'
// import mensaje from './modules/mensaje';
import mensajeSis from './modules/mensajeSistema'
import gestEvaluacion from './modules/gestionEvaluacion'
import progDocente from './modules/progDocente'

import visorContenido from './modules/visorContenido'
// import pmp from './modules/paqueteModuloPrincipal'
import wizard from './modules/wizard'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    globals,
    nivelesGrados,
    areas,
    login,
    mensajeSis,
    gestEvaluacion,
    progDocente,
    visorContenido,
    wizard
  },

  state: {

    idGrupo: 0,
    valor1: {},
    alumno: false,
    tipoDocumentos: [],
    tipoAllDocumentos: [],
    DptoUbigeo1: [],
    paises: [],
    nacionalidad: [],
    estadosCiviles: [],
    religiones: [],
    aseguradoras: [],
    discapacidades: [],
    idprueba: [],
    tituloMenu: null,
    logo: `${API_URL}/${sessionStorage.ruta_avatar_persona}${sessionStorage.avatar_persona}`,
    // Loader o spinner Jesus A
    // Objetos de loadingSpiner table circularbar
    hearChangeTab: false,
    loadingSpiner: {
      titulo: "",
      estado: false,
      color: "danger",
      colorDialog: "red",
      ancho: "600",
    },
    tabEstudiante: [],
    idsDiasSeleccionados:[],// variable que contiene el array de ids seleccionados
    fechasFeriado:[],
    diasEscolaresColegio:[]
  },

  getters: {
    getLogo:(state)=>{
          return state.logo;
    },
    getTipoDocumentos: (state) => {
      return state.tipoDocumentos;
    },    
    getPaises: (state) => {
      return state.paises;
    },
    getNacionalidades: (state) => {
      return state.nacionalidad;
    },
    getEstadosCiviles: (state) => {
      return state.estadosCiviles;
    },
    getReligiones: (state) => {
      return state.religiones;
    },
    getAseguradoras: (state) => {
      return state.aseguradoras;
    },
    getDiscapacidades: (state) => {
      return state.discapacidades;
    },
    getTituloMenu: (state) => {
      return state.tituloMenu;
    },
    getIdsDiasSeleccionados: (state) => {
     return state.idsDiasSeleccionados
    },  
  },

  mutations: {
    getArrayTab: (state, array) => {
      state.tabEstudiante = array;
    },
    // Mutaciones de loadingSpiner Table circular
    changedStateTab(state) {
      state.hearChangeTab = true;

      setTimeout(() => {
        state.hearChangeTab = false;
      }, 15000);
    },
    // "animate__animated animate__heartBeat"
    changedAnimationTab(state, payload) {
      state.tabEstudiante[1].class = payload.classAnimate;
      setTimeout(() => {
        state.tabEstudiante[1].class = "";
      }, 800);
    },
    mostrarLoading(state, payload) {
      state.loadingSpiner.titulo = payload.titulo;
      state.loadingSpiner.color = payload.color;
      state.loadingSpiner.estado = true;
      state.loadingSpiner.colorDialog = payload.colorDialog;
      state.loadingSpiner.ancho = payload.ancho;
    },
    ocultarLoading(state) {
      state.loadingSpiner.estado = false;
    },
    // FIN JESUS
    setLogo(state,payload){
        state.logo = payload.url;
    },
    setTipoDocument(state, payload) {
      state.tipoDocumentos = payload.tipoDocumentos;
    },
    setAllTipoDocument(state, payload) {
      state.tipoAllDocumentos = payload.tipoAllDocumentos;
    },  
    setDptoUbigeo1(state, payload) {
      state.DptoUbigeo1 = payload.DptoUbigeo1;
    },

    setPaises(state, payload) {
      state.paises = payload.paises;
    },
    setNacionalidades(state, payload) {
      state.nacionalidad = payload.nacionalidad;
    },

    setEstadosCiviles(state, payload) {
      state.estadosCiviles = payload.estadosCiviles;
    },

    setReligiones(state, payload) {
      state.religiones = payload.religiones;
    },

    setAseguradoras(state, payload) {
      state.aseguradoras = payload.aseguradoras;
    },

    setDiscapacidades(state, payload) {
      state.discapacidades = payload.discapacidades;
    },

    modalAlumno(state) {
      state.alumno = true;
    },

    closeAlumno(state) {
      state.alumno = false;
    },

    setTituloMenu(state, titulo) {
      state.tituloMenu = titulo;
    },

    setDiasSeleccionados(state, payload) {
      state.idsDiasSeleccionados = payload
    },

    set_dias_escolares(state,payload){
      state.diasEscolaresColegio = payload.diasEscolaresColegio
    },

    setFechasferiados(state, payload ){
      state.fechasFeriado = payload
    },

  },

  actions: {
    async getDptoUbigeo1(context,id_pais) {
      try {
        let response = await axios.get(`/mantenimiento/ubicacion1/${id_pais}`);
        context.commit("setDptoUbigeo1", {
          DptoUbigeo1: response.data,
        });

      } catch (error) {
        console.log(error);
      }
    },

    async getAllTiposDoc(context) {
      let sesion = sessionStorage;
      try {
        let response = await axios.get(`/mantenimiento/tipoDocumento/documentos/${sesion.id_colegio}/${sesion.id_pais}`);
        context.commit("setAllTipoDocument", {
          tipoAllDocumentos: response.data,
        });

      } catch (error) {
        console.log(error);
      }
    },

    async getAllTiposDocumentos(context) {
      let sesion = sessionStorage;
      try {
        let response = await axios.get(
          "/mantenimiento/tipoDocumento/documentos/" + sesion.id_colegio
        );
        context.commit("setTipoDocument", {
          tipoDocumentos: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //----------mostrar  paises----------------------------
    async getAllPaises(context) {
      try {
        let response = await axios.get("/mantenimiento/paises");
        context.commit("setPaises", {
          paises: response.data,
        });
      
      } catch (error) {
        console.log(error);
      }
    },

    //----------mostrar  nacionalidad ----------------------------
    async getAllNacionalidades(context) {
      try {
        let response = await axios.get("/mantenimiento/nacionalidades");
        context.commit("setNacionalidades", {
          nacionalidad: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //-------mostrar registros de Estados Civiles------------
    async getAllTiposEstadosCiviles(context) {
      try {
        let response = await axios.get("/mantenimiento/estadosciviles");
        context.commit("setEstadosCiviles", {
          estadosCiviles: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //----------mostrar religiones----------------------------
    async getAllReligiones(context) {
      try {
        let response = await axios.get("/mantenimiento/religiones");
        context.commit("setReligiones", {
          religiones: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //----------mostrar aseguradoras----------------------------
    async getAllAseguradoras(context) {
      try {
        let response = await axios.get("/mantenimiento/aseguradoras");
        context.commit("setAseguradoras", {
          aseguradoras: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //----------mostrar discapacidades----------------------------
    async getAllDiscapacidades(context) {
      try {
        let response = await axios.get("/mantenimiento/discapacidades");
        context.commit("setDiscapacidades", {
          discapacidades: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //---------dias donde el estudiante va al colegio--------------
    async getAlldiasEscolares(context){
      let sesion = sessionStorage;
      try{
        let response = await axios.post("/administrativo/calendarioAcademico/schooldays", {
          id_colegio: sesion.id_colegio,
          id_ano_lectivo: sesion.id_ano_lectivo,
        })

        context.commit("set_dias_escolares", { diasEscolaresColegio : response.data })
      }catch(error){
        console.log(error)
      }
    },

    //--------mostrar diasHabiles
    async getDiasHabiles(context){
      let sesion = sessionStorage;
      try{
        const response = await axios.get(`/administrativo/calendarioAcademico/${sesion.id_colegio}`)
        context.commit("setDiasSeleccionados", { idsDiasSeleccionados: response.data });
        // console.log("Datos obtenidos:", response.data);
        return response.data;
      }catch(error){
        console.log(error)
      }
    },
      //fechas feriados
    async getFechasFeriado( context ) {
        let sesion = sessionStorage;
        try {
            const response = await axios.get(`/administrativo/calendarioFeriado/${parseInt(sesion.id_colegio)}`)
            context.commit("setFechasferiados", { fechasFeriado:response.data})
            
        } catch (error) {
            console.log(error)
        }
    },  
    //---------modal alumnos -----------------
    modalAlumnos(context) {
      context.commit("modalAlumno");
    },

    //---------cerrar modal -----------------
    cerrarModal(context) {
      context.commit("closeAlumno");
    },    
  },
});